import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-fdb74c8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "confirm_box" };
const _hoisted_2 = { class: "item_confirm" };
import { VueFinalModal } from 'vue-final-modal';
import { watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalConfirm',
    props: {
        item: {
            type: String,
            required: true,
        }
    },
    setup(__props) {
        const props = __props;
        watch(() => props.item, (newVal) => {
            console.log("something to delete: " + newVal);
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VueFinalModal), _mergeProps({
                class: "confirm-modal",
                "content-class": "confirm-modal-content"
            }, _ctx.$attrs), {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "default"),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(props.item), 1),
                        _createElementVNode("button", {
                            class: "btn btn-primary btn-block confirm_btn",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('confirm', true)))
                        }, " Confirm ")
                    ])
                ]),
                _: 3
            }, 16));
        };
    }
});
